import script from "./MessageItemDirectChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageItemDirectChat.vue?vue&type=script&lang=ts&setup=true"

import "./MessageItemDirectChat.vue?vue&type=style&index=0&id=5995d11a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5995d11a"]])

export default __exports__